<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useModalStore } from '@/store/modal.store';
import { useTeamStore } from '@/store/team.store';
import { useAuthStore } from "@/store/auth.store";
import DefaultBtn from "../DefaultBtn.vue";

const props = defineProps<{
  closeSignal?: boolean
}>();

watch(() => props.closeSignal, () => {
  if (props.closeSignal) {
    close();
  }
});

const modalStore = useModalStore();
const teamStore = useTeamStore();
const authStore = useAuthStore();

const route = useRoute();

const userId = computed<string>(() => String(modalStore.modalPayload.id || route.params.userId || authStore.user.id || '-'));
const userName = computed(() => {
  const user = teamStore.usersMap.get(userId.value);
  return user ? user.name : 'User';
});

const loading = ref<boolean>(false);
const deactivate = ():void => {
  if (!loading.value) {
    loading.value = true;

    teamStore.deactivateUser(userId.value)
      .then(() => {
        modalStore.closeModal();
      })
      .finally(() => {
        loading.value = false;
      })
  }
};

const close = ():void => {
  if (!loading.value) {
    modalStore.closeModal();
  }
};

</script>


<template>
  <div class="modal modal--active">
    <div class="modal__body">
      <div class="modal__header">
        <p class="modal__subtitle">
          <span class="material-symbols-outlined">person</span>
          <span>User Deactivation</span>
        </p>
        <button @click="close" class="modal__close">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="modal__main">

        <div class="main-block">
          <img class="sure-img" src="@/assets/img/sure.svg" alt="sure">

          <h3 class="title_text">Are you sure?</h3>
          <p class="desc_text">Are you sure you want to deactivate {{userName}}?</p>
        </div>

        <div class="button-wrap">
          <DefaultBtn class="button-wrap__btn" :neutral="true" text="Close" @click="close" />
          <DefaultBtn class="button-wrap__btn" :loading text="Confirm" @click="deactivate" />
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>

.title_text {
  margin: 12px 0;
  color: #0F172A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
  letter-spacing: 0.2px;
}
.desc_text {
  margin-bottom: 32px;
  color: #0F172A;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
.sure-img {
  width: 124px;
  height: 124px;
}
.main-block {
  display: grid;
  justify-items: center;
  justify-content: center;
  align-items: center;
}
.button-wrap {
  display: flex;
  justify-content: center;
  gap: 11px;
}

.button-wrap__btn {
  min-width: 160px;
}
</style>